import { render } from "./QuestionQCMScene.vue?vue&type=template&id=12df43f7&scoped=true"
import script from "./QuestionQCMScene.vue?vue&type=script&lang=js"
export * from "./QuestionQCMScene.vue?vue&type=script&lang=js"

import "./QuestionQCMScene.vue?vue&type=style&index=0&id=12df43f7&scoped=true&lang=css"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12df43f7"]])

export default __exports__